/**
 *  @class
 *  @function Predictive Search
 */
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('.thb-predictive-search');
      this.cc = this.querySelector('.searchform--click-capture');
      this.headerSearchToggles = document.querySelectorAll('.thb-secondary-search');

      this.setupEventListeners();

    }
    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.predictiveSearchResults.addEventListener('focusout', this.close.bind(this));

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      this.cc.addEventListener('click', this.close.bind(this));
      this.headerSearchToggles.forEach((toggle) => {
        toggle.addEventListener('click', this.onHeaderSearchToggle.bind(this));
      });

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
      this.input.addEventListener('focus', this.open.bind(this));
    }
    onHeaderSearchToggle(event) {
      if (window.matchMedia('(max-width: 1067px)').matches) {
        event.preventDefault();
        if (this.classList.contains('is-mobile-open')) {
          this.close();
          return;
        }
        this.classList.add('is-mobile-open');
        document.body.classList.add('nbn-mobile-search-open');
        window.requestAnimationFrame(() => this.input.focus());
      }
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        document.body.classList.remove('open-search');
        this.predictiveSearchResults.setAttribute('inert', '');
        return;
      }
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {

      this.predictiveSearchResults.classList.add('loading');

      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,collection&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[limit_scope]')}=each&${encodeURIComponent('resources[options][unavailable_products]')}=hide&section_id=predictive-search`)
        .then((response) => {
          this.predictiveSearchResults.classList.remove('loading');
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.reorderFleshlightPredictiveResults();
      this.replaceFleshlightPredictiveResultsFromSearchPage();
      this.replaceGiftForWifePredictiveResultsFromCollections();
      setTimeout(() => this.reorderFleshlightPredictiveResults(), 50);

      let submitButton = this.querySelector('#search-results-submit');

      submitButton.addEventListener('click', () => {
        this.form.submit();
      });
    }

    isGiftForWifeSearch() {
      const normalized = this.getQuery().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      return normalized.includes('gift') && normalized.includes('wife');
    }

    ensureProductResultsContainer() {
      let container = this.predictiveSearchResults.querySelector('.thb-predictive-search--container');
      if (!container) {
        container = document.createElement('div');
        container.className = 'thb-predictive-search--container';
        this.predictiveSearchResults.prepend(container);
      }

      let productContent = container.querySelector('.thb-predictive-search--content');
      if (!productContent) {
        const label = document.createElement('div');
        label.className = 'thb-predictive-search--label z-1';
        label.textContent = 'Products';
        productContent = document.createElement('div');
        productContent.className = 'thb-predictive-search--content';
        container.prepend(label, productContent);
      }

      return productContent;
    }

    isGoodGiftForWifeCard(card) {
      const titleLink = card.querySelector('.product-card-title') || card.querySelector('.product-card-image-link');
      const title = titleLink ? (titleLink.getAttribute('title') || titleLink.textContent || '') : '';
      const href = titleLink ? titleLink.getAttribute('href') || '' : '';
      const text = `${title} ${href}`.toLowerCase();
      const isNoise = /gift card|personal shopping|coupon|book|dvd|card -|keychain|wine bag|lubricant|lube|cleaner|condom|bath bomb|handcuff|bondage rope|bondage tape/.test(text);
      const isToy = /vibrator|vibe|wand|rabbit|bullet|g-spot|g spot|clitoral|air pulse|stimulator|couples|couple|we-vibe|lelo|lush|sync|ring|massager|toy set|kit/.test(text);
      return !isNoise && isToy;
    }

    buildPredictiveResultFromProductCard(card) {
      const titleLink = card.querySelector('.product-card-title') || card.querySelector('.product-card-image-link');
      const image = card.querySelector('.product-primary-image') || card.querySelector('img');
      const price = card.querySelector('.price');
      const href = titleLink ? titleLink.getAttribute('href') : '';
      const title = titleLink ? (titleLink.getAttribute('title') || titleLink.textContent.trim()) : '';
      const item = document.createElement('product-card');
      const imageWrap = document.createElement('div');
      const imageLink = document.createElement('a');
      const info = document.createElement('div');
      const infoLink = document.createElement('a');

      item.className = 'product-cart-item';
      imageWrap.className = 'product-cart-item-image';
      imageLink.className = 'cart-product-link';
      imageLink.href = href;
      imageLink.title = title;
      info.className = 'product-cart-item-info';
      infoLink.className = 'cart-product-link';
      infoLink.href = href;
      infoLink.title = title;
      infoLink.textContent = title;

      if (image) {
        const imageEl = document.createElement('img');
        const srcset = image.getAttribute('data-srcset') || image.getAttribute('srcset') || '';

        imageEl.className = 'lazyload retina_size';
        imageEl.alt = title;
        imageEl.src = image.getAttribute('src') || (srcset ? srcset.split(' ')[0] : '');
        if (srcset) {
          imageEl.setAttribute('data-srcset', srcset);
        }
        imageLink.appendChild(imageEl);
      }

      imageWrap.appendChild(imageLink);
      info.appendChild(infoLink);

      if (price) {
        const priceClone = price.cloneNode(true);
        priceClone.classList.remove('large-price');
        info.appendChild(priceClone);
      }

      item.appendChild(imageWrap);
      item.appendChild(info);

      return item;
    }

    getCollectionProductRows(doc, limit) {
      const rows = [];
      const seen = new Set();

      Array.from(doc.querySelectorAll('product-card.product-card')).forEach((card) => {
        if (rows.length >= limit) {
          return;
        }
        const titleLink = card.querySelector('.product-card-title') || card.querySelector('.product-card-image-link');
        const href = titleLink ? titleLink.getAttribute('href') || '' : '';
        const handle = href.replace(/^.*\/products\//, '').replace(/[?#].*$/, '');

        if (!handle || seen.has(handle) || !this.isGoodGiftForWifeCard(card)) {
          return;
        }

        seen.add(handle);
        rows.push(this.buildPredictiveResultFromProductCard(card));
      });

      return rows;
    }

    replaceGiftForWifePredictiveResultsFromCollections() {
      const searchTerm = this.getQuery();
      if (!this.isGiftForWifeSearch()) {
        return;
      }

      const sources = [
        { url: '/collections/vibrators?sort_by=best-selling', limit: 7 },
        { url: '/collections/for-couples?sort_by=best-selling', limit: 7 }
      ];

      Promise.all(sources.map((source) => (
        fetch(source.url, { credentials: 'same-origin' })
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            return this.getCollectionProductRows(doc, source.limit);
          })
      )))
        .then((sourceRows) => {
          if (!searchTerm || searchTerm !== this.getQuery() || !this.isGiftForWifeSearch()) {
            return;
          }

          const combined = [];
          const seen = new Set();
          const maxRows = Math.max(...sourceRows.map((rows) => rows.length));

          for (let index = 0; index < maxRows && combined.length < 10; index += 1) {
            sourceRows.forEach((rows) => {
              const row = rows[index];
              const href = row && row.querySelector('.cart-product-link') ? row.querySelector('.cart-product-link').getAttribute('href') : '';
              const handle = href.replace(/^.*\/products\//, '').replace(/[?#].*$/, '');
              if (row && handle && !seen.has(handle) && combined.length < 10) {
                seen.add(handle);
                combined.push(row);
              }
            });
          }

          if (!combined.length) {
            return;
          }

          this.ensureProductResultsContainer().replaceChildren(...combined);
        })
        .catch(() => {});
    }

    reorderFleshlightPredictiveResults() {
      const searchTerm = this.getQuery().toLowerCase();
      if (!searchTerm.includes('fleshlight')) {
        return;
      }

      const productContent = this.predictiveSearchResults.querySelector('.thb-predictive-search--content');
      if (!productContent) {
        return;
      }

      const rows = Array.from(productContent.querySelectorAll('.product-cart-item')).map((card, index) => {
        const titleLink = card.querySelector('.product-cart-item-info .cart-product-link') || card.querySelector('.cart-product-link');
        const title = titleLink ? titleLink.textContent.trim() : '';
        const href = titleLink && titleLink.href ? titleLink.href : '';
        const text = `${title} ${href}`.toLowerCase();
        const isAccessory = /powder|launchpad|mount|fleshwash|cleaner|dryer|drying rack|screw dry/.test(text);
        const isQuickshot = text.includes('quickshot');
        const isFleshlightGirl = text.includes('fleshlight girl');
        const isFleshlight = text.includes('fleshlight');
        let bucket = 3;

        if (isAccessory) {
          bucket = 4;
        } else if (isFleshlightGirl && !isQuickshot) {
          bucket = 0;
        } else if (isFleshlight && !isQuickshot) {
          bucket = 1;
        } else if (isFleshlight && isQuickshot) {
          bucket = 2;
        }

        return { card, bucket, index };
      });

      rows
        .sort((a, b) => (a.bucket - b.bucket) || (a.index - b.index))
        .forEach((row) => productContent.appendChild(row.card));
    }

    replaceFleshlightPredictiveResultsFromSearchPage() {
      const searchTerm = this.getQuery();
      if (!searchTerm.toLowerCase().includes('fleshlight')) {
        return;
      }

      fetch(`/search?q=${encodeURIComponent(searchTerm)}&type=product`, { credentials: 'same-origin' })
        .then((response) => response.text())
        .then((text) => {
          if (!searchTerm || searchTerm !== this.getQuery()) {
            return;
          }

          const doc = new DOMParser().parseFromString(text, 'text/html');
          const searchCards = Array.from(doc.querySelectorAll('product-card.product-card')).slice(0, 10);
          const productContent = this.predictiveSearchResults.querySelector('.thb-predictive-search--content');

          if (!searchCards.length || !productContent) {
            return;
          }

          const rows = searchCards.map((card) => {
            const titleLink = card.querySelector('.product-card-title') || card.querySelector('.product-card-image-link');
            const image = card.querySelector('.product-primary-image') || card.querySelector('img');
            const price = card.querySelector('.price');
            const href = titleLink ? titleLink.getAttribute('href') : '';
            const title = titleLink ? (titleLink.getAttribute('title') || titleLink.textContent.trim()) : '';
            const item = document.createElement('product-card');
            const imageWrap = document.createElement('div');
            const imageLink = document.createElement('a');
            const info = document.createElement('div');
            const infoLink = document.createElement('a');

            item.className = 'product-cart-item';
            imageWrap.className = 'product-cart-item-image';
            imageLink.className = 'cart-product-link';
            imageLink.href = href;
            imageLink.title = title;
            info.className = 'product-cart-item-info';
            infoLink.className = 'cart-product-link';
            infoLink.href = href;
            infoLink.title = title;
            infoLink.textContent = title;

            if (image) {
              const imageEl = document.createElement('img');
              const srcset = image.getAttribute('data-srcset') || image.getAttribute('srcset') || '';

              imageEl.className = 'lazyload retina_size';
              imageEl.alt = title;
              imageEl.src = image.getAttribute('src') || (srcset ? srcset.split(' ')[0] : '');
              if (srcset) {
                imageEl.setAttribute('data-srcset', srcset);
              }
              imageLink.appendChild(imageEl);
            }

            imageWrap.appendChild(imageLink);
            info.appendChild(infoLink);

            if (price) {
              const priceClone = price.cloneNode(true);
              priceClone.classList.remove('large-price');
              info.appendChild(priceClone);
            }

            item.appendChild(imageWrap);
            item.appendChild(info);

            return item;
          });

          productContent.replaceChildren(...rows);
        })
        .catch(() => {
          this.reorderFleshlightPredictiveResults();
        });
    }

    close() {
      this.predictiveSearchResults.setAttribute('inert', '');
      document.body.classList.remove('open-search');
      this.classList.remove('is-mobile-open');
      document.body.classList.remove('nbn-mobile-search-open');
    }
    open() {
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
      const searchTerm = this.getQuery();
      if (searchTerm.length) {
        this.getSearchResults(searchTerm);
      }
    }
  }
  customElements.define('search-form', SearchForm);
}
